<div class="flex items-center justify-center grow bg-center bg-no-repeat page-bg">
    <div class="card max-w-[370px] w-full">
     
     <!-- Success State -->
     <div *ngIf="isSuccess" class="card-body flex flex-col gap-5 p-10 text-center">
      <div class="success-animation">
        <div class="checkmark-circle">
          <div class="checkmark"></div>
        </div>
      </div>
      <div class="text-center">
        <h3 class="text-lg font-semibold text-green-600 mb-2">Email Sent Successfully!</h3>
        <p class="text-sm text-gray-600 mb-4">
          If your email is registered, you will receive password reset instructions.
        </p>
        <div class="countdown-container">
          <p class="text-sm text-gray-500">
            Redirecting to login page in 
            <span class="countdown-number text-primary font-bold">{{ redirectCountdown }}</span> 
            seconds...
          </p>
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="(10 - redirectCountdown) * 10"></div>
          </div>
        </div>
        <button class="btn btn-outline btn-sm mt-3" (click)="router.navigate(['/auth'])">
          Go to Login Now
        </button>
      </div>
     </div>

     <!-- Form State -->
     <form *ngIf="!isSuccess" [formGroup]="requestPasswordForm" (ngSubmit)="onSubmit()" class="card-body flex flex-col gap-5 p-10" id="reset_password_enter_email_form" method="post">
      <div class="text-center">
       <span class="text-2sm text-gray-600 font-medium">
        Enter your email to reset password
       </span>
      </div>
      <div class="flex flex-col gap-1">
       <label class="form-label text-gray-900">
        Email
       </label>
       <input class="input" formControlName="email" placeholder="email@email.com" type="text" value=""/>
      </div>
      <a class="text-2sm link shrink-0 cursor-pointer" routerLink="/auth" (click)="getpasswordcomponent($event)">Never Mind?</a>
      
      <!-- Debug info (remove in production) -->
      <div class="text-xs text-gray-400" *ngIf="false">
        Form Valid: {{ requestPasswordForm.valid }}, Loading: {{ isLoading }}, Locked: {{ isLocked }}
      </div>
      
      <button type="submit" 
              class="btn btn-primary flex justify-center grow" 
              [disabled]="isButtonDisabled"
              [class.disabled]="isButtonDisabled"
              [attr.disabled]="isButtonDisabled ? true : null">
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        <span *ngIf="!isLoading">Continue</span>
        <span *ngIf="isLoading">Processing...</span>
        <i *ngIf="!isLoading" class="ki-filled ki-black-right"></i>
      </button>
     </form>
    </div>
   </div>